var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 797.52 187.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00529c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path206",
    className: "cls-1",
    d: "M215.79,47.12h43c17.4,0,30.38,7.63,30.38,23.7,0,11.78-6,18.34-16.47,21.82v.27c12.46,2.55,18.88,9.24,18.88,20.62,0,22.36-19.68,27-36.42,27H215.79Zm24.9,37h7c8.17,0,16.61-2,16.61-9.91,0-8.56-8-9.37-16.35-9.37h-7.22Zm0,38.82h7.36c9.11,0,18.61-1.34,18.61-10.84,0-10.18-9.77-11.11-18.35-11.11h-7.62Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    className: "cls-1",
    d: "M324.25,47.12h30.52l36,93.45H363.47l-7-19.94H321.44l-7.37,19.94h-25.3Zm15.26,19.29h-.27L327.19,103h23.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path214",
    className: "cls-1",
    d: "M394.25,47.12H426l31.6,63.47h.26l-.4-63.47H480.2v93.45H449.27L416.61,76.71h-.26l.79,63.86H394.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path218",
    className: "cls-1",
    d: "M488.65,47.12h24.9V85.28h.27l28.11-38.16h30L537.38,90.63l37.22,49.94H542.87l-29-42.44h-.27v42.44h-24.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path230",
    className: "cls-1",
    d: "M605.48,47.12h43c17.4,0,30.39,7.63,30.39,23.7,0,11.78-6,18.34-16.47,21.82v.27c12.46,2.55,18.87,9.24,18.87,20.62,0,22.36-19.67,27-36.41,27H605.48Zm24.9,37h7c8.17,0,16.6-2,16.6-9.91,0-8.56-8-9.37-16.33-9.37h-7.23Zm0,38.82h7.36c9.1,0,18.61-1.34,18.61-10.84,0-10.18-9.77-11.11-18.34-11.11h-7.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path234",
    className: "cls-1",
    d: "M686.78,47.12h44.45c16.6,0,30.12,7.5,30.12,23.57,0,12.45-5.89,20.75-17.94,23.56v.27c8,2.14,8.56,9.24,13.25,20.61l9.1,25.44h-26l-5.35-16.86c-5.09-16.07-8.31-20.09-17.54-20.09h-5.22v36.95h-24.9ZM711.68,86h6.55c8,0,18.22-.27,18.22-10.85,0-8.69-8.71-10.3-18.22-10.3h-6.55Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    className: "cls-1",
    d: "M772.62,47.12h24.9v93.45h-24.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path248",
    className: "cls-1",
    d: "M159,0H28.65C12.83,0,0,13.14,0,29.35V158.41c0,16.06,12.59,29.11,28.21,29.35H158.9c15.82,0,28.65-13.14,28.65-29.35l.06-129.06C187.61,13.14,174.79,0,159,0M44.13,172.72l-7.1.08A15.7,15.7,0,0,1,21.44,157l0-1.25V36.57l.05-6.43c.32-8.44,6.74-15.23,15.13-15.23H51c13.1,0,23.72,11.4,23.72,24.82a24.51,24.51,0,0,1-6.82,17.06L31.06,94.22l34.57,35.2a24.65,24.65,0,0,1,7.14,17.23c0,14.4-12.81,26.07-28.64,26.07m106.27-.12-64.44,0s7.44-16.1,7.44-26.07c0-12.16-4.06-23-10.42-30.19l-22-22.47L83.43,70.59c6.7-6.29,11.15-17.46,11.15-30.19,0-10.08-2.79-19-7.27-25.49h15.61c13.1,0,23.73,11.4,23.73,24.82a24.56,24.56,0,0,1-6.82,17.06l-36.18,37,75.13,76.61a15.92,15.92,0,0,1-8.38,2.16m15.73-23.92L112.29,93.8l25.65-26.06c5.21-6.53,8.53-16.35,8.53-27.34,0-10.14-2.83-19.3-7.35-25.78l11.47.35a15.69,15.69,0,0,1,15.58,15.8Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBri);
export default __webpack_public_path__ + "static/media/bri.82c9857ef72d7c4d9321c25ccfee0980.svg";
export { ForwardRef as ReactComponent };